// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel.discriminator = undefined;
EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel.additionalProperties = false;
EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel.attributeTypeMap = [
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "AccountExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
];
//# sourceMappingURL=enterpriseCoordinatorAccountServiceModelsAccountExternalIdModel.js.map